/** Logo cabecera HT: columna C (área impresa C5:E65), texto en D–E. */
export const HT_HEADER_LOGO = {
  col: 2.06,
  row: 5.45,
  width: 255,
  height: Math.round(255 / (412 / 167)),
};
